var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEligepasajeros(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "53px",
    viewBox: "0 0 76 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/passenger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/passenger",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face-id-2",
    transform: "translate(18.921053, 3.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4827895,32.7377895 C20.7275201,33.9204505 18.4303746,33.9204505 16.6751053,32.7377895 C15.7586042,32.0715321 14.4784576,32.2547521 13.785638,33.1513423 C13.0928183,34.0479324 13.2384587,35.3328969 14.1143684,36.0516842 C17.3488902,38.4916019 21.8090046,38.4916019 25.0435263,36.0516842 C25.919436,35.3328969 26.0650764,34.0479324 25.3722568,33.1513423 C24.6794371,32.2547521 23.3992905,32.0715321 22.4827895,32.7377895 L22.4827895,32.7377895 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.1578947,
    cy: 26.0263158,
    r: 2.78947368
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14,
    cy: 26.0263158,
    r: 2.78947368
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1052632,27.4210529 L39.1052632,20.4473684 C39.1052632,9.6632821 30.3630337,0.921052923 19.5789474,0.921052923 C8.79486105,0.921052923 0.0526315789,9.6632821 0.0526315789,20.4473684 L0.0526315789,27.4210529 C0.0526315789,38.2051391 8.79486094,46.9473684 19.5789474,46.9473684 C30.3630338,46.9473684 39.1052632,38.2051391 39.1052632,27.4210529 L39.1052632,27.4210529 Z M19.5789474,41.3684211 C11.8798517,41.3591987 5.64080127,35.1201483 5.63157895,27.4210526 L5.63157895,21.1447368 C5.63157895,20.7595909 5.94380142,20.4473684 6.32894737,20.4473684 L8.42105263,20.4473684 C12.0222632,20.4473684 19.3223158,21.3344211 24.706,15.3900526 C24.821798,15.2626915 24.9857621,15.1898186 25.1578947,15.1892085 C25.3302504,15.188769 25.4946211,15.2618227 25.6097895,15.3900526 C27.5898803,17.5936816 30.1883874,19.1490917 33.0660526,19.8532105 C33.337567,19.9222905 33.5272901,20.1672057 33.5263195,20.4473684 L33.5263195,27.4210526 C33.5170935,35.1201483 27.278043,41.3591987 19.5789474,41.3684211 Z",
    id: "Shape",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEligepasajeros);
export default __webpack_public_path__ + "static/media/icon_eligepasajeros.62d65d222d5d15931d02f825d33b1c5e.svg";
export { ForwardRef as ReactComponent };